import { useRef, useEffect, useState } from "react";
import { ReactComponent as ChevronDown } from "../../../../assets/icons/chevron-down.svg";

export function AttemptSelect({
  value,
  onChange,
  options = [],
}: {
  value: string;
  onChange: (value: string) => void;
  options?: any[];
}) {
  const [show, setShow] = useState(false);
  const selectedOption = options?.find((opt) => opt.value === value);
  const containerRef = useRef(null);

  useEffect(() => {
    // Implement outside click handler
    function handleClickOutside(event: MouseEvent) {
      if (
        containerRef.current &&
        !(containerRef.current as HTMLElement).contains(event.target as Node)
      ) {
        setShow(false);
      }
    }

    // Bind the event listener
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      // Unbind the event listener on clean up
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const optionList = options || [];

  return (
    <div className="relative w-[100px] flex items-center justify-center rounded-full bg-[#F4F4F5]" ref={containerRef}>
      <button
        onClick={() => setShow(!show)}
        className="w-fit h-[30px] flex items-center gap-2 justify-center"
      >
        <div className="w-fit text-center font-medium text-text2 text-[13px]">
          {selectedOption?.label || "Select"}
        </div>
        <ChevronDown className={`${show ? "rotate-[180deg]" : ""} w-3 h-3 [&_path]:stroke-black`} />
      </button>
      {show && (
        <div className="absolute z-[2] top-8 left-0 w-[100px] bg-white shadow-lg rounded-lg flex flex-col">
          {optionList?.map((opt) => (
            <button
              onClick={() => {
                onChange(opt.value);
                setShow(false);
              }}
              className="h-[30px] w-full py-2 flex items-center font-medium justify-center hover:bg-gray-100 text-[11px]"
            >
              {opt.label}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
